/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placewebsitedailylimiterror4Inputs */

const en_placewebsitedailylimiterror4 = /** @type {(inputs: Placewebsitedailylimiterror4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10 websites have been read today already. Try again tomorrow, or create the place without a website.`)
};

const de_placewebsitedailylimiterror4 = /** @type {(inputs: Placewebsitedailylimiterror4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heute wurden schon 10 Websites gelesen. Morgen geht es wieder, oder leg den Ort ohne Website an.`)
};

/**
* | output |
* | --- |
* | "10 websites have been read today already. Try again tomorrow, or create the place without a website." |
*
* @param {Placewebsitedailylimiterror4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebsitedailylimiterror4 = /** @type {((inputs?: Placewebsitedailylimiterror4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebsitedailylimiterror4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebsitedailylimiterror4(inputs)
	return de_placewebsitedailylimiterror4(inputs)
});
export { placewebsitedailylimiterror4 as "placeWebsiteDailyLimitError" }